// import React, { useState, useEffect } from "react";
// import { useLocation, useNavigate } from "react-router-dom";
// import { toast, ToastContainer } from "react-toastify";
// import "react-toastify/dist/ReactToastify.css";

// const UpdateVehicle = () => {
//   const location = useLocation();
//   const navigate = useNavigate();
//   const initialData = location.state?.responseData || {};

//   const [editableData, setEditableData] = useState(initialData);

//   useEffect(() => {
//     console.log("Received Data for Update:", editableData);
//   }, [editableData]);

//   const handleInputChange = (e) => {
//     const { name, value } = e.target;
//     setEditableData((prev) => ({ ...prev, [name]: value }));
//   };
  
//   const handleSaveChanges = async () => {
//     if (!editableData.ID || !editableData.VTYPE) {
//       toast.warn("ID and Service Name are required.");
//           // console.log("hello viky",editableData.ServiceName)

//       return;
//     }
    
//     const updateData = new URLSearchParams({
//       SecurityKey: "abcd",
//       TableName: "VehicleTypes",
//       WhereCondition: `ID=${editableData.ID}`,
//     });
    
//     Object.entries(editableData).forEach(([key, value]) => {
//       if (value !== undefined && value !== null && key !== "ID") {
//         updateData.append(key, value.toString());
//       }
//     });

//     try {
//       const response = await fetch(
//         "http://etour.responseinfoway.com/restapi/updatedata.aspx",
//         {
//           method: "POST",
//           headers: {
//             "Content-Type": "application/x-www-form-urlencoded",
//             Accept: "application/json",
//           },
//           body: updateData.toString(),
//         }
//       );

//       const textResponse = await response.text();
//       console.log("Raw Response:", textResponse);

//       let jsonResponse;
//       try {
//         jsonResponse = JSON.parse(textResponse);
//       } catch {
//         toast.success("Update successful ");
//         navigate("/showvehicletype");
//         return;
//       }

//       if (jsonResponse?.Response?.[0]?.Status === "Ok") {
//         toast.success("✅ Data updated successfully!");
//         navigate("/showvehicletype", { state: { updatedItem: editableData } });
//       } else {
//         toast.error("❌ Update failed: " + (jsonResponse.message || "Unknown error"));
//       }
//     } catch (error) {
//         toast.success("Update successful ");
//         navigate("/showvehicletype");
//     }
//   };

//   return (
//     <div className="update-container">
//       <ToastContainer position="top-right" autoClose={3000} hideProgressBar />
//       <h1>🔄 Update Vehicle Type</h1>

//       <form>
//         {/* Hidden ID Field */}
//         <input type="hidden" name="ID" value={editableData.ID || ""} readOnly />

//         <div className="input-group mt-3">
//           <label>Service Name</label>
//           <input
//             type="text"
//             name="VTYPE"
//             value={editableData.VTYPE || ""}
//             onChange={handleInputChange}
//             required
//           />
//         </div>

//         <button
//           type="button"
//           className="save-changebtn"
//           onClick={handleSaveChanges}
//         >
//           ✅ Save Changes
//         </button>
//       </form>
//     </div>
//   );
// };

// export default UpdateVehicle;







// import React, { useState, useEffect } from "react";
// import { useLocation, useNavigate } from "react-router-dom";
// import { toast, ToastContainer } from "react-toastify";
// import "react-toastify/dist/ReactToastify.css";
// import { SECURITY_KEY } from "../../../globals";

// const UpdateVehicle = () => {
//   const location = useLocation();
//   const navigate = useNavigate();
//   const initialData = location.state?.responseData || {};

//   const [editableData, setEditableData] = useState(initialData);

//   useEffect(() => {
//     console.log("Received Data for Update:", editableData);
//   }, [editableData]);

//   const handleInputChange = (e) => {
//     const { name, value } = e.target;
//     setEditableData((prev) => ({ ...prev, [name]: value }));
//   };

//   const handleSaveChanges = async () => {
//     if (!editableData.ID || !editableData.VTYPE) {
//       toast.warn("ID and Service Name are required.");
//       return;
//     }

//     // 🔹 Log old vs new values
//     console.log("🔍 Changes to be updated:");
//     Object.keys(editableData).forEach((key) => {
//       if (editableData[key] !== initialData[key]) {
//         console.log(`Field: ${key} | Old: ${initialData[key]} | New: ${editableData[key]}`);
//       }
//     });

//     const updateData = new URLSearchParams({
//       SecurityKey: SECURITY_KEY, // ✅ Using global variable instead of hardcoded value
//       TableName: "VehicleTypes",
//       WhereCondition: `ID=${editableData.ID}`,
//     });

//     Object.entries(editableData).forEach(([key, value]) => {
//       if (value !== undefined && value !== null && key !== "ID") {
//         updateData.append(key, value.toString());
//       }
//     });

//     try {
//       const response = await fetch(
//         "https://etour.responseinfoway.com/restapi/updatedata.aspx", // ✅ Changed to HTTPS
//         {
//           method: "POST",
//           headers: {
//             "Content-Type": "application/x-www-form-urlencoded",
//             Accept: "application/json",
//           },
//           body: updateData.toString(),
//         }
//       );

//       const textResponse = await response.text();
//       console.log("Raw Response:", textResponse);

//       let jsonResponse;
//       try {
//         jsonResponse = JSON.parse(textResponse);
//       } catch {
//         toast.success("Update successful ");
//         navigate("/showvehicletype");
//         return;
//       }

//       if (jsonResponse?.Response?.[0]?.Status === "Ok") {
//         toast.success("✅ Data updated successfully!");
//         navigate("/showvehicletype", { state: { updatedItem: editableData } });
//       } else {
//         toast.error("❌ Update failed: " + (jsonResponse.message || "Unknown error"));
//       }
//     } catch (error) {
//       toast.success("Update successful ");
//       navigate("/showvehicletype");
//     }
//   };

//   return (
//     <div className="update-container">
//       <ToastContainer position="top-right" autoClose={3000} hideProgressBar />
//       <h1>🔄 Update Vehicle Type</h1>

//       <form>
//         {/* Hidden ID Field */}
//         <input type="hidden" name="ID" value={editableData.ID || ""} readOnly />

//         <div className="input-group mt-3">
//           <label>Service Name</label>
//           <input
//             type="text"
//             name="VTYPE"
//             value={editableData.VTYPE || ""}
//             onChange={handleInputChange}
//             required
//           />
//         </div>

//         <button
//           type="button"
//           className="save-changebtn"
//           onClick={handleSaveChanges}
//         >
//           ✅ Save Changes
//         </button>
//       </form>
//     </div>
//   );
// };

// export default UpdateVehicle;



import React, { useState, useEffect } from "react";
import { useLocation, useNavigate, Link } from "react-router-dom";
import { showToast } from "../../../utils/customToast";
import { SECURITY_KEY } from "../../../globals";
import { apiWithLog } from "../../../utils/apiWithLog";
import "../Ledger/UpdateLedger.css";

const UpdateVehicle = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const initialData = location.state?.responseData || {};
  const [editableData, setEditableData] = useState(initialData);
  const [loading, setLoading] = useState(false);

  const BASE_REST_API_URL = process.env.REACT_APP_BASE_REST_API_URL;
  const BASE_API_URL = process.env.REACT_APP_BASE_API_URL;

  useEffect(() => {
    console.log("Received Data for Update:", editableData);
  }, [editableData]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setEditableData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSaveChanges = async () => {
    if (loading) return;
    if (!editableData.ID || !editableData.VTYPE) {
      showToast.warn("ID and Vehicle Type are required.");
      return;
    }

    const payload = {
      VTYPE: editableData.VTYPE ? editableData.VTYPE.trim() : "",
    };

    try {
      setLoading(true);
      const res = await apiWithLog({
        method: "PUT",
        url: `${BASE_API_URL}/vehicletypes/${editableData.ID}`,
        data: payload,
        module: "VehicleTypeMaster",
        action: "E",
        headers: {
          "Content-Type": "application/json",
        },
      });

      const result = res.data;
      console.log("Update Response:", result);

      if ((res.status === 200 || res.status === 201) && (result?.status || result?.success)) {
        showToast.save("Data updated successfully!");
        setTimeout(() => {
          navigate("/showvehicletype", {
            state: { updatedItem: editableData },
          });
        }, 1200);
      } else {
        showToast.error(result?.message || "Update failed.");
      }
    } catch (error) {
      console.error("Update error:", error);
      showToast.error(
        error?.response?.data?.message ||
        error?.response?.data?.error ||
        "Update failed due to server error."
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="update_ledger_container">
      {/* Header & Breadcrumbs */}
      <div className="update_ledger_header_bar">
        <div className="update_ledger_title_group">
          <h4 className="update_ledger_title">Update Vehicle Type</h4>
          <div className="update_ledger_breadcrumbs">
            <Link to="/home">Home</Link>
            <span>/</span>
            <Link to="/showvehicletype">Vehicle Types</Link>
            <span>/</span>
            <span>Update</span>
          </div>
        </div>
      </div>

      {/* Form Card */}
      <div className="update_ledger_card">
        <div className="update_ledger_card_header">
          <h5>Vehicle Type Details</h5>
        </div>

        <form onSubmit={(e) => { e.preventDefault(); handleSaveChanges(); }}>
          {/* Hidden ID */}
          <input type="hidden" name="ID" value={editableData.ID || ""} readOnly />

          <div className="update_ledger_grid">
            <div className="update_ledger_field">
              <label htmlFor="VTYPE">
                Vehicle Type <span className="required">*</span>
              </label>
              <input
                type="text"
                id="VTYPE"
                name="VTYPE"
                value={editableData.VTYPE || ""}
                onChange={handleInputChange}
                placeholder="e.g. SEDAN, SUV, INNOVA"
                required
              />
            </div>
          </div>

          <div className="update_ledger_actions">
            <Link to="/showvehicletype" className="update_ledger_cancel_btn">
              Cancel
            </Link>
            <button
              type="submit"
              className="update_ledger_submit_btn"
              disabled={loading}
            >
              {loading ? "Saving Changes..." : "Save Changes"}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default UpdateVehicle;
